export default {
  breakpointDefault: 960,
  breakpointHeader: 850,
  breakpointSectionBullets: 660,

  headerHeight: 67,
};
